/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/destination_canvas_notification_dismissed/:workflow_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdCacheKeys } from "./constants";
import type {
  PostEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdProps,
  PostEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult,
} from "./types";

export const postEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId = reactQueryMutationAdapter(
  postEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdCacheKeys,
  (
    props: PostEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdProps
  ): Promise<PostEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/destination_canvas_notification_dismissed/${props.workflowId}`,
      "POST",
      { dismissed_at: props.dismissedAt }
    );
  }
);
